import './header.scss';
import { useHistory, useLocation } from 'react-router-dom'

import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { logout, fetchProfile } from '../../../redux/actions/userAction';
import Modal from "../../../components/UI/Modal";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getToken } from '../../../utils/common';
import Button from '../../UI/Button';
import Input from '../../UI/Input';
import { InitialStateUIType, InitialStateUserType } from "../../../typings/state";
import { useBreadcrumbs } from '../../../contexts/BreadcrumbContext';
import kelaseLogo from "../../../assets/images/logo/logo-kelase-home.png";
import {
  Bell,
  Book,
  ChevronLeft,
  ChevronRight,
  LogOut, Plus,
  Settings,
  ShoppingCart,
  SquareUserRound,
  User, X
} from "lucide-react";
import { UseAppDispatch } from "../../../redux/store";
import { HIDE_SIDEBAR } from "../../../redux/types";

interface IHeader{
  title?:string;
  onBack?: Function;
  user?: InitialStateUserType;
  showBreadcrumb?: boolean;
  logout?: Function;
  fetchProfile?: Function;
  greetings?: boolean
}
const HeaderComponent = (props: IHeader) => {
  const history = useHistory();
  const dispatch = UseAppDispatch();
  const location = useLocation();
  const [showSidebar, setShowSidebar] = useState(false);
  const [modalGroup, setModalGroup] = useState(false);
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const { breadcrumbs: contextBreadcrumbs } = useBreadcrumbs();
  const UI = useSelector(
    (state: { UI: InitialStateUIType }) => state.UI
  );
  const profile = props.user?.profile;
  useEffect(() => {
    if(UI.showSidebar){
      setShowSidebar(true);
    }
  }, [UI.showSidebar]);
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const getAvatarUrl = (avatar: string) => {
    return avatar
  };

  const goBack = () => {
    if (props.onBack) {
      props.onBack();
    } else {
      history.goBack();
    }
  };

  const getBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter(x => x);
    const breadcrumbMap: { [key: string]: string } = {
      'dashboard': 'Beranda',
      'course': 'Kursus',
      'competency': 'Asesmen',
      'riasec': 'RIASEC',
      'account': 'Akun',
      'my-course': 'Kursus Saya',
      'my-competencies': 'Asesmen Saya',
      'profile': 'Profil',
      'transaction': 'Transaksi',
      'payment': 'Pembayaran'
    };

    return pathnames.map((pathname, index) => {
      const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
      const isLast = index === pathnames.length - 1;
      const label = breadcrumbMap[pathname] || pathname;

      return { label, path: routeTo, isLast };
    });
  };
  const onCloseSidebar = () => {
    setShowSidebar(false);
    dispatch({ type: HIDE_SIDEBAR });
  }

  const onLogout = async () => {
    if (props.logout) {
      await props.logout();
    }
    onCloseSidebar();
  };

  const goTo = (path: string) => {
    history.push(path);
    onCloseSidebar();
  };

  const onSubmitGroup = async (data: any) => {
    setModalGroup(false);
    reset();
    
    try {
      await axios({
        url: process.env.REACT_APP_API_URL + '/profile/apply-group',
        method: 'post',
        data: { group_code: data.group_code },
        headers: {
          "Authorization": `Bearer ${getToken()}`,
        },
      });
      
      toast.success("Tambah Grup Berhasil!", {
        position: toast.POSITION.TOP_CENTER
      });
      if (props.fetchProfile) {
        props.fetchProfile();
      }
    } catch (err) {
      toast.error("Gagal menambah grup", {
        position: toast.POSITION.TOP_CENTER
      });
    }
  };

  const menuItems = [
    {
      key: 'profile',
      label: 'Sunting Profil',
      path: '/account/profile',
      icon: User,
      badge: null
    },
    {
      key: 'course',
      label: 'Kursus Saya',
      path: '/account/my-course',
      icon: Book,
      badge: profile?.my_courses
    },
    {
      key: 'competency',
      label: 'Asesmen Saya',
      path: '/account/my-competencies',
      icon: SquareUserRound,
      badge: profile?.my_competencies
    },
    {
      key: 'transaction',
      label: 'Transaksi',
      path: '/transaction',
      icon: ShoppingCart,
      badge: profile?.pending_transaction,
      badgeType: 'danger'
    },
  ];

  const breadcrumbs = contextBreadcrumbs.length > 0 ? contextBreadcrumbs : getBreadcrumbs();
  const showBreadcrumbs = props.showBreadcrumb && breadcrumbs.length > 0;
  return (
    <>
      <header className="sticky top-0 z-50  border-b border-border backdrop-blur-sm bg-card/95">
        <div
          className={`container mx-auto px-4 pt-4 ${
            !showBreadcrumbs ? "pb-4" : ""
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src={kelaseLogo} alt="Kelase" className="h-8 w-auto" />
            </div>

            <div className="flex items-center gap-2">
              {/*<Button variant="ghost" size="icon" className="relative">*/}
              {/*  <Bell className="h-5 w-5" />*/}
              {/*  <span className="absolute top-1 right-1 h-2 w-2 bg-accent rounded-full" />*/}
              {/*</Button>*/}
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setShowSidebar(true)}
              >
                <Settings className="h-5 w-5" />
              </Button>
            </div>
          </div>
          {showBreadcrumbs ? (
            <>
              <div className="breadcrumb-container">
                <button onClick={goBack} type="button">
                  <ChevronLeft />
                </button>
                <nav className="breadcrumb-nav">
                  {breadcrumbs.map((crumb, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && (
                        <span className="breadcrumb-separator">/</span>
                      )}
                      {crumb.isLast ? (
                        <span className="breadcrumb-current">
                          {crumb.label}
                        </span>
                      ) : (
                        <button
                          className="breadcrumb-link"
                          onClick={() => crumb.path && history.push(crumb.path)}
                          type="button"
                        >
                          {crumb.label}
                        </button>
                      )}
                    </React.Fragment>
                  ))}
                </nav>
              </div>
            </>
          ) : (
            <>
              {props.greetings && (
                <div className="mt-4">
                  <h1 className="text-xl font-bold">
                    Hai, {profile?.fullname} 👋
                  </h1>
                  <p className="text-sm text-muted-foreground mt-1">
                    Siap lanjutkan perjalanan karirmu hari ini?
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      </header>

      {/* Sidebar Overlay */}
      {showSidebar && (
        <div className="sidebar-overlay" onClick={() => onCloseSidebar()}>
          <div className="sidebar-content" onClick={(e) => e.stopPropagation()}>
            {/* Sidebar Header */}
            <div className="sidebar-header">
              <h5 className="sidebar-title">Menu</h5>
              <button
                className="sidebar-close-btn"
                onClick={() => onCloseSidebar()}
                type="button"
              >
                <X />
              </button>
            </div>

            {/* User Profile Section */}
            <div className="sidebar-profile bg-primary gradient-primary">
              <div className="profile-avatar">
                {profile?.avatar ? (
                  <img
                    src={getAvatarUrl(profile.avatar)}
                    alt={profile.fullname}
                  />
                ) : (
                  <div className="avatar-placeholder">
                    {profile?.fullname ? getInitials(profile.fullname) : "U"}
                  </div>
                )}
              </div>
              <div className="profile-info">
                <h5 className="profile-name">{profile?.fullname}</h5>
                <span className="profile-email">{profile?.email}</span>
                <div className="profile-groups">
                  {profile?.groups && profile.groups.length > 0
                    ? profile.groups.map((g) => (
                        <span
                          className="group-badge"
                          key={`group-${g.group.id}`}
                        >
                          {g.group.name}
                        </span>
                      ))
                    : null}
                  <button
                    className="add-group-btn"
                    onClick={() => setModalGroup(true)}
                    type="button"
                  >
                    <Plus /> Grup
                  </button>
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="sidebar-menu">
              {menuItems.map((item) => (
                <button
                  key={item.key}
                  className="menu-item"
                  onClick={() => goTo(item.path)}
                  type="button"
                >
                  <div className="menu-item-content">
                    <item.icon size={"1.5rem"} />
                    <span>{item.label}</span>
                  </div>
                  <div className="menu-item-right">
                    {item.badge !== null &&
                      item.badge !== undefined &&
                      item.badge > 0 && (
                        <span
                          className={`menu-badge ${
                            item.badgeType === "danger"
                              ? "badge-danger"
                              : "badge-primary"
                          }`}
                        >
                          {item.badge}
                        </span>
                      )}
                    <ChevronRight />
                  </div>
                </button>
              ))}

              <button
                className="menu-item logout-item"
                onClick={onLogout}
                type="button"
              >
                <div className="menu-item-content">
                  <LogOut size={"1.5rem"} />
                  <span>Keluar</span>
                </div>
                <ChevronRight />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Group Modal */}
      <Modal
        show={modalGroup}
        onHide={() => setModalGroup(false)}
        centered={true}
      >
        <Modal.Body>
          <div className="form-wrapper">
            <form onSubmit={handleSubmit(onSubmitGroup)}>
              <div className="form-group mb-3">
                <label className="form-label">Kode Grup</label>
                <Input
                  placeholder="Masukan Kode Grup"
                  name="group_code"
                  register={register}
                  errors={errors}
                  block={true}
                  rules={{
                    required: "Kode Grup tidak boleh kosong",
                  }}
                />
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button outline onClick={() => setModalGroup(false)}>
            Batal
          </Button>
          <Button
            primary
            className="min-w-75px"
            onClick={handleSubmit(onSubmitGroup)}
          >
            Kirim
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = { logout, fetchProfile };

const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);

export default Header;